<template>
    <input type="number"
    :min="field.product.minPrice"
    :max="field.product.maxPrice"
    step="0.01"
    v-bind:value="value"
    v-on:input="$emit('filled-out', $event.target.value)"
    v-on:change="$emit('filled-out', $event.target.value)"
    v-on:blur="$emit('filled-out', $event.target.value)"
    />
</template>

<script>
  export default {
    props: {
      field: {},
      value: '',
    }
  };
</script>
